import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MaquinaMovimientoService } from 'src/app/services/maquina-movimiento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-maquinas-maestro-modal-ver-movimiento',
  templateUrl: './modal-ver-movimiento.component.html',
  styleUrls: ['../maquinas-maestro.component.scss'],
  providers: [SecurityService]
})
export class MaquinasMaestroModalVerMovimientoComponent implements OnInit {

  @ViewChild('verMovimiento', { static: true }) verMovimientoModal: ModalDirective;

  // Form
  formData: FormGroup

  // Data & Tmp
  public rutEmpresa: number
  public sucursalCodigo: number
  public numeroPlaca: any
  public fallbackNumeroDocumentoMovimiento: string = null;
  public fallbackNumeroContrato: string = null;
  loading: boolean = false
  listaMovimientos: Array<any> = null
  listaMovimientosAll: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  private currentPayload: any = null
  PintarRow: number;
  estadoItem: boolean = true;
  movEsp: any = null;
  // estado de carga para los botones
  loadingVoucher: boolean = false;
  loadingPdf: boolean = false;

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    public rutService: RutService,
    private maquinaMovimientoService: MaquinaMovimientoService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('MAQUINAS VER MOVIMIENTO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
  }

  show(mov) {
    this.numeroPlaca = mov.numero_placa
    this.fallbackNumeroDocumentoMovimiento = mov && mov.numero_documento ? String(mov.numero_documento) : null;
    this.fallbackNumeroContrato = mov && mov.numero_contrato != null ? String(mov.numero_contrato) : null;
    this.buscar(1)
    this.verMovimientoModal.show()

  }

  load(mov) {
    this.show(mov)
  }

  ClickedRow(index, mov){
    this.PintarRow = index;
    this.estadoItem = false;
    this.movEsp = mov;
    console.log("DAME EL MOVIMIENTO ", mov)
  }

  buscar(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = null
    this.log('inputParams', JSON.stringify(this.formData))

    const inputParams = {
      filtro: {
        exacto: {
          empresa_rut: this.rutEmpresa,
          numero_placa: this.numeroPlaca,
        }
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1
    }

    this.currentPayload = inputParams


    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.maquinaMovimientoService.obtenerMovimientos(inputParams, ({ mensajes, respuesta }) => {
       const ok = respuesta !== null
       if (!ok) {
         this.messageRendererService.showErrors(mensajes)
         return
       }

       const { registros } = respuesta
       // Ordenar desc para que la primera fila sea el último movimiento
       this.listaMovimientosAll = _.orderBy(
         registros || [],
         [
           (m) => (m && m.fecha_asignacion ? new Date(m.fecha_asignacion).getTime() : 0),
           (m) => (m && m.codigo != null ? Number(m.codigo) : 0),
         ],
         ['desc', 'desc']
       )

       this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
       this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
       this.paginationContext.CurrentPage = pageNumber
       this.loading = false
       this.showPage(this.paginationContext.CurrentPage);

    })
  }


  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    this.loadingPdf = true;
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.filtro.exacto.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.maquinaMovimientoService.obtenerMovimientosPDF(inputParams, ({ mensajes, respuesta }) => {
      this.loadingPdf = false;
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  downloadExcelPdfEspecifico(type: 'XLS' | 'PDF') {
    this.loadingVoucher = true;
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual
    inputParams.filtro.exacto.codigo = this.movEsp.codigo;
    inputParams.filtro.exacto.origen = this.movEsp.origen;
    inputParams.filtro.exacto.destino = this.movEsp.destino;
    inputParams.filtro.exacto.fecha_asignacion_formato = new Date(this.movEsp.fecha_asignacion);
    inputParams.filtro.exacto.fecha_entrega_formato = this.movEsp.fecha_entrega;
    inputParams.filtro.exacto.detalle_destino = this.movEsp.detalle_destino;
    inputParams.filtro.exacto.direccion_codigo = this.movEsp.direccion_codigo;
    inputParams.filtro.exacto.cliente_proveedor_rut = this.movEsp.cliente_proveedor_rut;

    inputParams.filtro.exacto.retornaPDF = type === 'PDF'

    this.maquinaMovimientoService.obtenerMovimientosPDFEspecifico(inputParams, ({ mensajes, respuesta }) => {
      this.loadingVoucher = false;
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }


  CerrarMovimiento(){
    this.estadoItem = true;
    this.PintarRow = null;
  }

}
